import React, { useContext } from 'react';

import { POPUPS } from '@common/constants/popups';
import { PopupContext } from '@app/dev/contexts/popup';

import { useTranslation } from '@common/hooks/translation';
import CountDownComponent from '../countDownClock';

const CashOutType = () => {
  const t = useTranslation();
  const [{ openPopup }] = useContext(PopupContext);

  return (
    <div className="popup-content popup-small">
      <div className="popup-main-content">
        <CountDownComponent second={30} />
        <div className="mini-logo-container" />
        <p className="text-center">{t('Select cash out type')}</p>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          className="popup-cancel-button"
          onClick={() => openPopup(POPUPS.CASHOUT)}
        >
          {t('Cashout')}
        </button>
        <button
          type="button"
          className="popup-confirm-button"
          onClick={() => openPopup(POPUPS.CASHOUT_BY_TICKET)}
        >
          {t('Ticket')}
        </button>
      </div>
    </div>
  );
};

export default CashOutType;
